export default "__VITE_ASSET__c833fd3d__"